/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Compare_DescriptionInputs */

const en_directory_tools_compare_description = /** @type {(inputs: Directory_Tools_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how Seek AI stacks up against other launch pads.`)
};

const zh_directory_tools_compare_description = /** @type {(inputs: Directory_Tools_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看看 Seek AI 与其他发布平台的差异。`)
};

/**
* | output |
* | --- |
* | "See how Seek AI stacks up against other launch pads." |
*
* @param {Directory_Tools_Compare_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_compare_description = /** @type {((inputs?: Directory_Tools_Compare_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Compare_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_compare_description(inputs)
	return zh_directory_tools_compare_description(inputs)
});
export { directory_tools_compare_description as "directory.tools.compare.description" }